var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.value
        ? _c("grid-cell-image", {
            attrs: { col: _vm.column, value: _vm.value, css: "full" }
          })
        : _vm._e(),
      !_vm.value && !_vm.column.component.props.multiple
        ? _c("q-btn", {
            staticClass: "uploader-box q-pa-md",
            attrs: {
              color: "primary",
              flat: "",
              "text-color": "primary",
              align: "center",
              icon: "add_a_photo",
              label: "Select Image"
            },
            on: { click: _vm.triggerSelect }
          })
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.value && _vm.apiEndpoint,
              expression: "value && apiEndpoint"
            }
          ],
          staticClass: "q-ma-sm"
        },
        [
          _c("q-uploader", {
            ref: "uploadwidget",
            attrs: {
              url: _vm.apiEndpoint,
              method: "POST",
              multiple: !!_vm.column.component.props.multiple,
              headers: _vm.headers,
              "hide-upload-button": true,
              "hide-upload-progress": true,
              "additional-fields": _vm.additionalFields,
              "auto-expand": true,
              clearable: true,
              align: "center",
              name: "image",
              extensions: ".gif,.jpg,.jpeg,.png",
              "hide-underline": ""
            },
            on: {
              uploaded: _vm.handleUploadComplete,
              fail: _vm.handleFail,
              add: _vm.handleAdd,
              "remove:abort": _vm.handleRemove,
              "remove:cancel": _vm.handleRemove
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }